import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { alignSelf, color, fontSize, lineHeight, space } from 'styled-system';

import { Button } from 'common/components/Button';
import { useOpenDrawer } from 'common/hooks/drawer';
import { useLocalization } from 'common/providers/LocaleProvider';
import { cursor, textDecoration, textTransform, whiteSpace } from 'common/theme/system-utilities';

interface MoreInfoButtonProps {
  drawerContent: string;
  drawerTitle: string;
}

const UnstyledStyledButton = styled(Button)<any>`
  ${alignSelf};
  ${color};
  ${fontSize};
  ${lineHeight};
  ${textDecoration};
  ${textTransform};
  ${cursor};
`;

const StyledButton = (props: ComponentProps<typeof UnstyledStyledButton>) => (
  <UnstyledStyledButton
    kind="bare"
    alignSelf="flex-end"
    p="sp_4"
    mb="sp_12"
    color="sys.neutral.border.default"
    fontSize="fs_12"
    textDecoration="underline"
    textTransform="lowercase"
    cursor="pointer"
    {...props}
  />
);

const UnstyledDrawerContent = styled.p<any>`
  ${space};
  ${fontSize};
  ${lineHeight};
  ${color};
  ${whiteSpace};
`;

const DrawerContent = (props: ComponentProps<typeof UnstyledDrawerContent>) => (
  <UnstyledDrawerContent
    p="sp_16"
    fontSize={['fs_14', 'fs_16', null, 'fs_18']}
    lineHeight={['lh_20', 'lh_22', null, 'lh_28']}
    color="sys.neutral.border.strong"
    whiteSpace="pre-line"
    {...props}
  />
);

export const MoreInfoButton = ({ drawerTitle, drawerContent }: MoreInfoButtonProps) => {
  const { t } = useLocalization();
  const drawerPayload = {
    title: drawerTitle,
    content: <DrawerContent>{t(drawerContent)}</DrawerContent>,
  };
  const handleMoreInfoClick = useOpenDrawer(drawerPayload, {
    preventDefault: true,
  });

  return <StyledButton onClick={handleMoreInfoClick}>*{t('h24_more_info')}</StyledButton>;
};
